import { render, staticRenderFns } from "./article_table.vue?vue&type=template&id=7f003fad&scoped=true"
import script from "./article_table.vue?vue&type=script&lang=ts"
export * from "./article_table.vue?vue&type=script&lang=ts"
import style0 from "./article_table.vue?vue&type=style&index=0&id=7f003fad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f003fad",
  null
  
)

export default component.exports